export default "__VITE_ASSET__uOx1mfBc__"